"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPreorderLookupOrderComponent = void 0;
const shared_1 = require("../../../../mma/shared");
const orderStatus_service_1 = require("../../../services/orderStatus.service");
const constants = require("../../../util/constants");
class CSPreorderLookupOrderComponent {
    constructor(orderService, genericContentService) {
        this.orderService = orderService;
        this.genericContentService = genericContentService;
        this.removingInsurance = false;
    }
    getOrderSummary() {
        var _a, _b, _c;
        let monthlyInstallment = 0;
        let planPrice = 0;
        const protectionPrice = 0;
        for (const details of this.subcriptionDetails) {
            if ((details === null || details === void 0 ? void 0 : details.status) !== constants.cancelled) {
                if (details === null || details === void 0 ? void 0 : details.dpp) {
                    monthlyInstallment = monthlyInstallment + Number(details.estimatedPrice);
                    if (!isNaN(details === null || details === void 0 ? void 0 : details.mandatoryDownPayment)) {
                        monthlyInstallment = monthlyInstallment - details.mandatoryDownPayment;
                    }
                    if (!isNaN(details === null || details === void 0 ? void 0 : details.voluntaryDownPayment)) {
                        monthlyInstallment = monthlyInstallment - details.voluntaryDownPayment;
                    }
                    if (!isNaN(details === null || details === void 0 ? void 0 : details.discountsApplied)) {
                        monthlyInstallment = monthlyInstallment - details.discountsApplied;
                    }
                    monthlyInstallment = monthlyInstallment / Number(details === null || details === void 0 ? void 0 : details.dppTermLength);
                }
                if (((_a = details === null || details === void 0 ? void 0 : details.insuranceDetails) === null || _a === void 0 ? void 0 : _a.removingInsurance) === false && ((_b = details === null || details === void 0 ? void 0 : details.insuranceDetails) === null || _b === void 0 ? void 0 : _b.deviceCSN)) {
                    this.getInsurancePrice(details.insuranceDetails.deviceCSN, details.insuranceDetails.insuranceType, details);
                }
                else if (((_c = details === null || details === void 0 ? void 0 : details.insuranceDetails) === null || _c === void 0 ? void 0 : _c.removingInsurance) === true) {
                    this.removingInsurance = true;
                }
                planPrice = planPrice + Number(details.planPrice);
            }
        }
        monthlyInstallment = monthlyInstallment > 0 ? monthlyInstallment : 0;
        this.monthlyInstallment = monthlyInstallment;
        this.planPrice = planPrice;
        this.protectionPrice = protectionPrice;
        this.monthlyTotal = this.monthlyInstallment + this.planPrice + this.protectionPrice;
        if (this.removingInsurance) {
            this.getRemovingInsuranceContent();
        }
    }
    setErrorMessage(errorMessage) {
        const errorMsg = {
            errorMessage
        };
        return errorMsg;
    }
    /**
     * Print Order Status
     */
    printOrderStatusSection(isLoggedInUser) {
        if (isLoggedInUser) {
            this.orderStatus = document.querySelector('cs-mma-preorderdetails').innerHTML;
        }
        else {
            document.getElementById('order-sidebar').style.display = 'none';
            this.orderStatus = document.querySelector('cs-preorderdetails').innerHTML;
        }
        const popupWindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWindow.document.open();
        popupWindow.document.write('<html><head><link href="/resources/css/compiled-css/order-status/order-status.css" rel="stylesheet"/></head><body>' +
            this.orderStatus +
            '<script type="text/javascript">window.print();setTimeout(function() {window.close();}, 500)</script></html>');
        popupWindow.document.close();
        document.getElementById('order-sidebar').style.display = 'block';
    }
    /**
     * return the compatible insurance price based on selected device
     */
    getInsurancePrice(deviceCSN, insuranceCSN, details) {
        this.orderService.getInsuranceDetails(deviceCSN).subscribe((data) => {
            if (data.length > 0) {
                for (const insuranceTier of data[0].tiers) {
                    if (insuranceTier.phoneInsuranceCsn === insuranceCSN) {
                        details.insuranceDetails.phoneInsuranceDisplayName = insuranceTier.phoneInsuranceDisplayName;
                        const price = Number(insuranceTier.price);
                        this.protectionPrice = this.protectionPrice + price;
                        details.insuranceDetails.price = price;
                        this.monthlyTotal = this.monthlyTotal + this.protectionPrice;
                    }
                }
            }
        });
    }
    getRemovingInsuranceContent() {
        this.genericContentService.getGenericContent('genericContentInsuranceCartRemoved').subscribe((data) => {
            this.contentInsuranceCartRemoved = data.contentText;
        });
    }
}
exports.CSPreorderLookupOrderComponent = CSPreorderLookupOrderComponent;
//# sourceMappingURL=preorderlookup.component.js.map